import React from 'react'
import PropTypes from 'prop-types'

export default class MaterialItem extends React.Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    material: PropTypes.shape().isRequired,
    onEditClicked: PropTypes.func.isRequired,
    onDeleteClicked: PropTypes.func.isRequired
  }

  render() {
    const name = this.props.material.name ? this.props.material.name.trim() : ''
    const units = this.props.material.units ? this.props.material.units.trim() : ''
    const cost = this.props.material.cost ? ('$' + this.props.material.cost) : ''
    return (
      <div>
        <div style={{ ...styles.listRowContainer, ...styles.row(this.props.index) }}>
          <div style={{ ...styles.listRowColumn(true), ...styles.listMainWidth }}>{ name }</div>
          <div style={{ ...styles.listRowColumn(), ...styles.listMinorWidth }}> { cost }</div>
          <div style={{ ...styles.listRowColumn(), ...styles.listMinorWidth }}> { units }</div>
          <div style={{ ...styles.listRowColumn(), ...styles.listIconWidth, ...styles.actions }} >
            <div onClick={this.props.onEditClicked} title='Edit material'>
              <i className='material-icons' style={styles.action}>mode_edit</i>
            </div>
            <div onClick={this.props.onDeleteClicked} title='Delete material' style={{ marginLeft: 8 }}>
              <i className='material-icons' style={styles.action}>delete</i>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  row: index => ({
    backgroundColor: index % 2 ? 'rgba(251, 235, 201, 0.30)' : 'rgba(255, 255, 255, 0.01)',
    borderBottom: 'none'
  }),
  listRowColumn: isName => ({
    color: '#757575',
    fontSize: 14,
    marginLeft: isName ? 16 : 0,
    paddingTop: 8,
    paddingBottom: 8
  }),
  listRowContainer: {
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  listMainWidth: {
    width: 250
  },
  listMinorWidth: {
    width: 75
  },
  listIconWidth: {
    width: 44
  },
  actions: {
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'row'
  },
  action: {
    cursor: 'pointer',
    fontSize: 18
  }
}



// WEBPACK FOOTER //
// ./src/settings/modules/materials/MaterialItem.js